import React from 'react';
import { SelectCard, CommonButton } from '@Components';
import { RECIPIENT_SCREEN } from '../../../utils/constants';
import { Beneficiary, ISelectRecipientProps } from '../../../utils/interface';
import { SelectRecipientContents } from '../style';
import { BANK_CIRCLE_ICON } from '@Images';
import { NF_SCREENS } from '../../../root/screenConstants';

export const SelectRecipient: React.FC<ISelectRecipientProps> = (props): React.ReactElement => {
  const {
    beneList,
    destinationCurrency,
    showAddRecipientScreen,
    changeNiumForexScreen,
    tempTransactionId,
    updateTempTransactionWithId,
    storeSelectedBeneId,
    activateLoader,
    disableLoader,
    dispatch
  } = props;

  const selectBeneGoToFemaDocUpload = async (bene: Beneficiary) => {
    dispatch(activateLoader());
    const tempTransResp = await dispatch(
      updateTempTransactionWithId(tempTransactionId, {
        beneficiary_id: bene?.beneficiary_id
      })
    );
    dispatch(disableLoader());
    if (tempTransResp) {
      dispatch(storeSelectedBeneId(bene?.beneficiary_id));
      dispatch(changeNiumForexScreen(NF_SCREENS.upload_documents));
    } else return;
  };

  return (
    <SelectRecipientContents>
      {beneList?.map(({ full_name, bank_name, bank_account_number }, index) => (
        <SelectCard
          index={index}
          cardIcon={BANK_CIRCLE_ICON}
          cardIconText={destinationCurrency || ''}
          heading={full_name}
          subHeading={`${bank_name} *${bank_account_number?.slice(-4)}`}
          extraInfo="Bank deposit"
          key={index}
          onClick={() => selectBeneGoToFemaDocUpload(beneList[index])}
        />
      ))}
      <div className="addNewButton">
        <CommonButton
          type="link"
          text={RECIPIENT_SCREEN.selectRecipient.addNewRecipient}
          onClick={showAddRecipientScreen}
        />
      </div>
    </SelectRecipientContents>
  );
};
